// removed by extract-text-webpack-plugin
module.exports = {"client":"src-components-Client----client-module---client---3ibt2 src-styles----index---panel---2Guib src-styles----index---container---1O8Oe","row":"src-components-Client----client-module---row---29Vq3 src-styles----index---row---1QX0w","title":"src-components-Client----client-module---title---3QOPV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Client/client.module.scss
// module id = 339
// module chunks = 168707334958949